export default __webpack_public_path__ + "static/media/scan-success-color.85bc8ee6.svg";